import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { DropdownPanel } from "./DropdownMultiSelect";
import { Icon } from "../util/Icon";

export function ColumnFilter({ label, options, value, onChange, minWidth }) {
  const [open, setOpen] = useState(false);
  const [panelPos, setPanelPos] = useState({ top: 0, left: 0 });
  const btnRef = useRef(null);
  const panelRef = useRef(null);
  const isActive = value.length > 0;

  const handleOpen = () => {
    const rect = btnRef.current.getBoundingClientRect();
    const PANEL_HEIGHT = 320;
    const spaceBelow = window.innerHeight - rect.bottom;
    const pos = spaceBelow >= PANEL_HEIGHT || spaceBelow >= rect.top
      ? { top: rect.bottom + 2, left: rect.left }
      : { bottom: window.innerHeight - rect.top + 2, left: rect.left };
    setPanelPos(pos);
    setOpen(true);
  };

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (!panelRef.current?.contains(e.target) && !btnRef.current?.contains(e.target))
        setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <th style={{ verticalAlign: "bottom", minWidth: minWidth ?? 110, userSelect: "none" }}>
      <div className="d-flex align-items-center gap-1 fw-semibold">
        <span style={{ whiteSpace: "nowrap" }}>{label}</span>
        <button
          ref={btnRef}
          onClick={handleOpen}
          className="btn btn-sm p-0 border-0 bg-transparent"
          style={{ color: isActive ? "#0d6efd" : "#adb5bd", lineHeight: 1 }}
          title={isActive ? `${value.length} filter(s) active` : "Filter"}
        >
          <Icon iconName={isActive ? "FunnelFill" : "Funnel"} size={13} />
        </button>
      </div>
      {open && createPortal(
        <DropdownPanel
          panelRef={panelRef}
          options={options}
          initialPending={value.length === 0 ? [...options] : [...value]}
          getOptionLabel={(s) => s}
          getOptionValue={(s) => s}
          onConfirm={(selected) => {
            onChange(selected.length === options.length ? [] : selected);
            setOpen(false);
          }}
          onCancel={() => setOpen(false)}
          style={panelPos}
        />,
        document.body
      )}
    </th>
  );
}

export function PlainHeader({ label, minWidth }) {
  return (
    <th style={{ verticalAlign: "bottom", minWidth }}>
      <span className="fw-semibold">{label}</span>
    </th>
  );
}
